<template>
  <div>
    <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    <v-flex xs12 text-xs-left>
      <v-btn
        class="ml-4 mu-4 font-weight-light"
        color="success"
        v-bind:disabled="loading"
        v-on:click="newFormulation()"
      >New Formulation</v-btn>
    </v-flex>
    <DisplayTable
      v-if="!loading"
      v-bind:data="formulations"
      v-bind:columns="columns"
      v-bind:routerLinkPath="'formulation'"
      v-bind:routerLinkKey="'formulationId'"
      v-bind:tableTitle="'Formulations'"
    ></DisplayTable>
  </div>
</template>

<script>
var restHelper = require("../restHelper").default
var middleware = require("../middleware").default
import DisplayTable from "@/views/DisplayTable"

export default {
  components: {
    DisplayTable
  },
  data() {
    return {
      formulations: [],
      columns: [],
      loading: false
    }
  },
  async mounted() {
    middleware.run(this.$router)
    await this.init()
  },
  methods: {
    async init() {
      this.loading = true

      try {
        var result = await restHelper.getFormulations()
        this.loading = false
        this.formulations = result.data.formulations
        this.columns = [
          "formulationId",
          "fragranceDesc",
          "solutionName",
          "percentage",
          "runtime"
        ]
      } catch (error) {}

      this.loading = false
    },

    async newFormulation() {
      this.$router.push("/formulation/0")
    }
  }
}
</script>

